import Loader from '@/components/loader';

export function ErrorLoadingPickemHistory() {
  return <div className="p-6 text-center">Error loading pickems history</div>;
}

export function ErrorAuthNeededForHistory() {
  return (
    <div className="p-6 text-center">
      You need to be logged in to see your pickems history.
    </div>
  );
}

export function NoPickemsHistory() {
  return <div className="p-6 text-center">You have no pickems history.</div>;
}

export function HistoryLoading() {
  return (
    <div className="flex items-center justify-center p-6 text-center">
      <Loader />
    </div>
  );
}

export const getColorsByPercentage = (successPercentage: number) => {
  if (successPercentage < 33) {
    return '#EF4444'; // red-500
  }
  if (successPercentage < 66) {
    return '#F59E0B'; // amber-500
  }
  return '#22C55E'; // green-500
};
